import React from 'react';

interface BulkSelectionCountProps {
  /** Every selected RTU, including ones a search currently hides. */
  count: number;
  children: React.ReactNode;
}

/**
 * Shows the selected count next to the existing "Bulk Actions" button, e.g. "(2)". The button itself names the count for
 * assistive technology (RTUActions selectedCount); this visible count is therefore hidden from it.
 */
const BulkSelectionCount: React.FC<BulkSelectionCountProps> = ({ count, children }) => (
  <div className="rtu-bulk-count-wrap">
    {children}
    {count > 0 && (
      <span className="rtu-bulk-count" data-testid="rtu-bulk-count" aria-hidden="true">
        ({count})
      </span>
    )}
  </div>
);

export default BulkSelectionCount;
